import { LangProvider } from "./context/LangContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Pricing from "./components/Pricing";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <LangProvider>
      <div className="min-h-screen">
        <Navbar />
        <Hero />
        <Features />
        <Pricing />
        <Contact />
        <Footer />
      </div>
    </LangProvider>
  );
}
